/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CreateSnippetData, PatchSnippetData, Snippet } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function snippet(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Snippet)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Snippet))),
    });
    return Object.freeze({
        /**
         * Add or modify a `Snippet` by key.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns A response containing the JSON serialized snippet and return code 201.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/snippet`, createResponse.v, JSON.stringify(CreateSnippetData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the `Snippet` with the given id.
         *
         * @param arg The arguments to the function.
         * @param arg.snippetId The id of the snippet
         * @returns An empty response with return code 204
         */
        delete: async ({ snippetId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/snippets/${snippetId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Modify the `Snippet` with the given id.
         *
         * @param arg The arguments to the function.
         * @param arg.snippetId The id of the snippet to change.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204.
         */
        patch: async ({ snippetId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/snippets/${snippetId}`, patchResponse.v, JSON.stringify(PatchSnippetData.encode(requestBody)));
            return result;
        },
        /**
         * Get all snippets of the current user.
         *
         * @returns An array containing all snippets for the currently logged in user.
         */
        getAll: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/snippets/`, getAllResponse.v, undefined);
            return result;
        },
    });
}
